import React from 'react';
import agent from '../../../../agent';
import MeetingRoomWidget from './MeetingRoomWidget'
import LoaderWidget from '../Loader/LoaderWidget'
import {checkForUnauthorisedResponse} from '../../../Utils/ErrorHandler'

import { connect } from 'react-redux';

const mapStateToProps = state => ({
  notification:state.bookevent.notification
});

class MeetingRoomWidgetContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      events: [],
      loaded:false
    };
  }

  loadEvents(resourceId, time) {
    agent.MeetingRoom.getEvents(resourceId, time).then(
      res => {
        if(res.result) {
          this.setState({
            ...this.state,
            events:res.data,
            loaded:true
          })
        } else {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      },
      error => {
        if(!checkForUnauthorisedResponse(error, agent)) {
          this.setState({
            ...this.state,
            'loaded':true
          })
        }
      }
    )
  }

  componentDidMount() {
    this.refresh();
  }

  refresh() {
    const resourceId = this.props.resourceId;
    const date = new Date();
    const time = (date.getHours() * 100) + (date.getMinutes());
    this.loadEvents(resourceId, time);
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.props.notification) {
      const notification = this.props.notification ? this.props.notification.notification : null;
      const oldNotification = prevProps.notification ? prevProps.notification.notification : null;
      const resourceId = this.props.resourceId;

      if( (!oldNotification && notification && notification.resourceId === resourceId) || //no previous notification
          (oldNotification && notification && notification.resourceId === resourceId && oldNotification.startTime !== notification.startTime) //new notification has a different start time
        ) {
        this.refresh();
      }

    }
  }

  render() {
    if(this.state.loaded) {
      return (
        <MeetingRoomWidget {...this.props} onWidgetRefresh={this.refresh.bind(this)} refreshInterval={300} events={this.state.events}/>
      )
    } else {
      return (
        <LoaderWidget {...this.props}/>
      )
    }
  }
}

export default connect(mapStateToProps)(MeetingRoomWidgetContainer);



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/MeetingRoomWidget/MeetingRoomWidgetContainer.js